// ABOUTME: Registry mapping action types to their corresponding components.
// ABOUTME: Add new action types here to extend the ProgressCenter functionality.

import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ShippingProgressAction from './actions/ShippingProgressAction';
import ShippingProgressActionIndProdBatchAction from './actions/ShippingProgressActionIndProdBatch';

export const ACTION_TYPES = {
    shipping_progress: {
        component: ShippingProgressAction,
        icon: LocalShippingIcon,
        defaultTitle: "creating_labels",
    },
    shipping_progress_individual_product_batch: {
        component: ShippingProgressActionIndProdBatchAction,
        icon: LocalShippingIcon,
        defaultTitle: "creating_labels",
    },
};
